var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebookGradient = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 30.7393V70.4238C0.406304 72.2345 0.908773 74.0134 1.86317 75.5814C2.81757 77.1497 4.1903 78.4518 5.84334 79.3572L42.0706 99.1995C43.7237 100.105 45.599 100.582 47.5077 100.582C49.4166 100.582 51.2916 100.105 52.9447 99.1995L89.1721 79.3572C90.8252 78.4518 92.1978 77.1497 93.1523 75.5814C94.1068 74.0134 94.6091 72.2345 94.6091 70.4238V30.7393C94.6091 28.9286 94.1068 27.1497 93.1523 25.5817C92.1978 24.0134 90.8252 22.7112 89.1721 21.8059L52.9447 1.96358C51.2916 1.05819 49.4166 0.581543 47.5077 0.581543C45.599 0.581543 43.7237 1.05819 42.0706 1.96358L5.84334 21.8059C4.1903 22.7112 2.81757 24.0134 1.86317 25.5817C0.908773 27.1497 0.406304 28.9286 0.40625 30.7393Z",
    fill: "#4375C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57166 74.5417L3.57158 74.5415C2.80514 73.2823 2.40629 71.8624 2.40625 70.4238V30.7393C2.40625 30.7393 2.40625 30.7393 2.40625 30.7393C2.4063 29.3006 2.80516 27.8807 3.57158 26.6215L3.57166 26.6214C4.33871 25.361 5.44999 24.3016 6.80409 23.56L5.84334 21.8059L6.8041 23.56L43.0313 3.71773C44.386 2.97577 45.9303 2.58154 47.5077 2.58154C49.0853 2.58154 50.6293 2.97576 51.984 3.71773L88.2113 23.56L88.2114 23.56C89.5655 24.3016 90.6767 25.361 91.4439 26.6215L91.4439 26.6216C92.2104 27.8807 92.6091 29.3006 92.6091 30.7393V70.4238C92.6091 71.8625 92.2104 73.2824 91.4439 74.5415L91.4439 74.5416C90.6767 75.8021 89.5655 76.8614 88.2113 77.6031L51.984 97.4454C50.6293 98.1874 49.0853 98.5815 47.5077 98.5815C45.9303 98.5815 44.386 98.1874 43.0313 97.4454L6.80415 77.6031C6.80414 77.6031 6.80412 77.6031 6.8041 77.6031C5.44993 76.8613 4.33867 75.802 3.57166 74.5417Z",
    stroke: "url(#paint0_linear_13440_32918)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.716 64.8351V52.1576H53.9061L54.7033 46.9081H49.716V43.5032C49.716 42.0706 50.4159 40.6674 52.6422 40.6674H54.9075V36.2029C54.9075 36.2029 52.8464 35.8496 50.8826 35.8496C46.7897 35.8496 44.1064 38.3616 44.1064 42.9046V46.8982H39.5371V52.1478H44.1064V64.8253H49.7257L49.716 64.8351Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13440_32918",
    x1: 0.406248,
    y1: 0.342359,
    x2: 114.998,
    y2: 63.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4195D2",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook_gradient.06de5344882e23c6de1fb54760963428.svg";